import React from 'react';
export default function Privacidad() {
  return <section className="bg-[#F7F9FC] min-h-[60vh] py-16" data-id="element-593">
      <div className="container mx-auto max-w-4xl px-4" data-id="element-594">
        <h1 className="text-3xl font-bold mb-6 text-[#0E1113]" data-id="element-595">Política de Privacidad</h1>
        <div className="space-y-4 text-[#5B6166]" data-id="element-596">
          <p data-id="element-597">Usamos buenas prácticas de seguridad y cifrado. Tus documentos se usan sólo para tu pre-evaluación.</p>
          <p data-id="element-598">No vendemos tus datos. Puedes solicitar la eliminación de tu información cuando lo estimes conveniente.</p>
        </div>
      </div>
    </section>;
}